import { useParams } from "react-router-dom";
import metadata from "../data/site.config.json";
import useI18n from "./useI18n";

const usePageMetadata = () => {
  const params = useParams();
  const { t } = useI18n();
  const pageId: string =
    params.pageId === undefined ? metadata.defaultPage : params.pageId;

  const page = (metadata.pages as any)[pageId];

  return {
    pageId,
    defaultPage: metadata.defaultPage,
    localDB: metadata.localDB,
    title: t(page.title),
    primary_key: page.primary_key || "id",
    store: page.store,
    form_fields: page.form_fields,
    list_columns: page.list_columns,
  };
};

export default usePageMetadata;
